export const getPremiumUpsellIconClasses = (): string => {
  return 'icon-crown icon -premium-color';
};

/**
 * Trial CTAs must gate on this, not on `window.PMW.premiumDialogs.isEligibleForFreeTrial()` — that one
 * checks premium level and the new-user cookie but no country, so it says "eligible" where trials are
 * not offered. Delegates to the legacy component so both stacks resolve it the same way, once.
 */
export const isCurrentUserEligibleForFreeTrial = async (): Promise<boolean> => {
  return window.PMW.premiumDialogs.isTrialAvailableForUser();
};
